<div class="intel-ranking-panel">
    <div class="intel-ranking-header">
        <p>{{title}}</p>
        <app-month-picker
            [year]="year" [month]="month"
            (yearChange)="year = $event" (monthChange)="month = $event"
            (periodApplied)="onPeriodApplied()">
        </app-month-picker>
    </div>
    <table class="intel-mini-table">
        <thead>
            <tr>
                <th>#</th>
                <th class="th-name">{{columnLabel}}</th>
                <th>Km recorridos</th>
                <th>Gasto total</th>
                <th>Costo por km</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows; let i = index" (click)="goToHistory(row.id)">
                <td>{{i + 1}}</td>
                <td class="cell-name">{{row.name}}</td>
                <td>{{formatKm(row.km_total)}}</td>
                <td>{{formatCurrency(row.gasto_total)}}</td>
                <td [ngClass]="costPerKmClass(row.efficiency)">{{row.cost_per_km !== null ? formatCurrency(row.cost_per_km) : '—'}}</td>
            </tr>
        </tbody>
    </table>
    <a class="intel-ranking-footer" (click)="goToRanking()">
        Ver ranking completo
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </a>
</div>
